import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { Direction } from '@microsoft/fast-web-utilities';
export class ThemeProviderComponent extends FoundationElement {
    constructor() {
        super(...arguments);
        this.direction = Direction.ltr;
        this.theme = 'light';
        this.skin = 'gotoadmin';
        this.automatic = false;
        this.rebranding2021 = true;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setRebrandingFlagOnBody(this.rebranding2021);
    }
    // TODO Revisit this with the release of CORE-V3
    updateStyles(newTheme, isAutomatic, newSkin) {
        const skin = newSkin || this.skin;
        if (newTheme === undefined || isAutomatic === undefined) {
            return;
        }
        const isForcedDarkTheme = isAutomatic === false && newTheme === 'dark';
        const isHighContrast = skin === 'msteams' && newTheme === 'high-contrast';
        this.classList.toggle('enable-darkmode', isAutomatic);
        this.classList.toggle('theme-dark', isForcedDarkTheme);
        this.classList.toggle('enable-high-contrast', isHighContrast);
        if (this.isGlobalThemeProvider()) {
            document.body.classList.toggle('theme-dark', isForcedDarkTheme);
            document.body.classList.toggle('enable-darkmode', isAutomatic);
            document.body.classList.toggle('enable-high-contrast', isHighContrast);
        }
    }
    themeChanged(_oldValue, newTheme) {
        this.updateStyles(newTheme, this.automatic);
    }
    automaticChanged(_oldValue, isAutomatic) {
        this.updateStyles(this.theme, isAutomatic);
    }
    skinChanged(_oldValue, newSkin) {
        this.updateStyles(this.theme, this.automatic, newSkin);
    }
    isGlobalThemeProvider() {
        const themeProvider = this.getGlobalThemeProvider();
        // The current theme provider is in shadow dom and is not found by the document.querySelector call.
        // Then it is most likely to be the only one in the page.
        // If there's another bug regarding this consider adding an extra attribute to the theme provider.
        return themeProvider === null || themeProvider === this;
    }
    getGlobalThemeProvider() {
        // We take the first element that is a theme provider, either the chameleon one or the current one.
        return document.querySelector(`chameleon-theme-provider, ${this.tagName}`);
    }
    setRebrandingFlagOnBody(flagValue) {
        if (this.isGlobalThemeProvider()) {
            document.body.toggleAttribute('rebranding2021', flagValue);
        }
    }
}
__decorate([
    attr
], ThemeProviderComponent.prototype, "theme", void 0);
__decorate([
    attr
], ThemeProviderComponent.prototype, "skin", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ThemeProviderComponent.prototype, "automatic", void 0);
__decorate([
    attr({ mode: 'boolean' })
], ThemeProviderComponent.prototype, "rebranding2021", void 0);
